import styled from "styled-components";

export const TableHeaderRow = styled.tr`
    th {
        padding: 0.5rem;
        text-align: left;
        vertical-align: top;
    }
`;
